const widgets = {
  BNW: "XXXXXXX-XXXXXXX-XXXXXXX-XXXXXXX",
};

export default widgets;
